<template>
  <div class="br-pricing-estimate">
    <div class="br-pricing-estimate__panel">
      <div class="br-pricing-estimate__panel__head br-pricing-estimate__panel__head--break">
        <h2>Cost Breakdown</h2>
        <currency-selector v-model="model.currency"/>
      </div>
      <div class="br-pricing-estimate__panel__body">
        <div class="br-pricing-estimate__summary">
          <div
            v-if="model.organization_type === 1"
            class="br-pricing-estimate__summary__item">
            <span class="text u-color-green"><i class="icon icon-c-check"/></span>
            <span class="text">Non-Profit Organization</span>
            <div class="text-group-vertical">
              <span class="text text--highlight">Discount Applied </span>
              <span class="text text--muted">(monthly savings)</span>
            </div>
          </div>
          <div class="br-pricing-estimate__summary__item">
            <span class="text u-color-green"><i class="icon icon-c-check"/></span>
            <span class="text">{{ planType }} A.I. Networking Community ({{ model.size | numeral }} invitees)</span>
            <div class="text-group-vertical">
              <span class="text text--highlight">{{ formatNumber(getPerMemberCost, '0,0.[00]') }} / member</span>
              <span class="text text--muted">(billed monthly)</span>
            </div>
          </div>
          <div
            v-for="addOn in model.add_ons"
            :key="addOn.id"
            class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--addon">
            <span class="text u-color-green"><i class="icon icon-c-check"/></span>
            <div class="text-group-vertical">
              <span class="text text--highlight">{{ addOn.label }}</span>
            </div>
            <div class="text-group-vertical">
              <span class="text text--highlight">{{ addOn.price > 0 ? formatNumber(addOn.price) : formatNumber(getManagementPrice) }}</span>
              <span class="text text--muted">(add-on)</span>
            </div>
          </div>
          <div class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--alt">
            <span class="text">Cost to Get Started:</span>
            <div class="text-group-vertical">
              <span class="text text--highlight">{{ formatNumber(getSetupFee) }}</span>
              <span class="text text--muted">(one-time cost)</span>
            </div>
          </div>
          <div class="br-pricing-estimate__summary__item br-pricing-estimate__summary__item--alt">
            <span class="text">Monthly Cost:</span>
            <div class="text-group-vertical">
              <span class="text text--highlight">{{ formatNumber(getMonthlyCostWithAddOns) }}</span>
              <span class="text text--muted">(billed monthly)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      class="button button--block u-border-radius"
      @click.prevent.stop="openModal">
      Edit Your Estimate
    </button>
  </div>
</template>

<script>
import Pricing from '@mixins/Pricing'
import CurrencySelector from '@components/CurrencySelector'

export default {
  components: {
    CurrencySelector
  },
  mixins: [
    Pricing
  ],
  props: {
    hash: {
      type: String,
      required: true
    }
  },
  created () {
    if (this.hash) {
      this.initModelByHash(this.hash)

      if (this.isEnterprise) {
        this.model.organization_type = 2
      }
    }

    this.initExchangeRate()
  },
  methods: {
    openModal () {
      this.$store.dispatch('modal/open', {
        name: 'pricing-plan-modal',
        params: this.getModelByHash(this.hash)
      })
    }
  }
}
</script>
